import {LOCATION_CHANGE} from 'redux-first-history'

import {getInitialState} from '@web/slices/error/slice'
import makeSlice from '@web/slices/error/sliceMaker'

const errorSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(LOCATION_CHANGE, () => {
            return getInitialState()
        })
    },
})

export default errorSlice.reducer
